























import {Component, Vue} from 'vue-property-decorator';
import RegisterDialog from '@/components/Views/Customer/RegisterDialog.vue';
import {Mixins} from 'vue-property-decorator';
import UserRoleMixin from '@/mixins/UserRoleMixin.vue';
import GlobalAlertMixin from '@/mixins/GlobalAlertMixin.vue';
import {Sync} from 'vuex-pathify';
import {nil} from '@/common';
import ForgotPasswordDialog from '@/components/Views/User/ForgotPasswordDialog.vue';

@Component({
    components: {ForgotPasswordDialog, RegisterDialog},
})
export default class Login extends Mixins(UserRoleMixin, GlobalAlertMixin) {
    private email = '';
    private password = '';
    private registerDialog = false;
    @Sync('ui/redirectPath') public redirectPath!: string|null;

    public mounted() {
        this.redirectAfterLogin();
    }

    public created() {
        this.redirectAfterLogin();
    }
    private attemptLogin() {
        this.$store.dispatch('auth/authenticate', {
            email: this.email,
            password: this.password,
            strategy: 'local',
        }).then(() => {
            this.redirectAfterLogin();
        }).catch((err) => {
            console.log(err);
            if (err.code === 401 || err.code === 400) {
                this.registerGuest(err);
            } else {
                this.showAlert(err);
            }

        });
    }

    /*private async attemptRegister() {
        const {User} = this.$FeathersVuex;
        try {
            const u = await new User({email: this.email, password: this.password});
            await u.save();
            (this.$refs.registerDialog as any).openWith(u, null);
        } catch (e) {
            this.showAlert(e);
        }
    }*/
    private async registerGuest(err) {
        const {User, Purchaser, Vendor} = this.$FeathersVuex;
        const u = await User.find({query: {email: this.email}});
        if (u.total !== 0) {
            // user already exists, this isn't a guest.
            console.log(`user already exists, this isn't a guest.`);
            console.log(u);
            this.showAlert(err);
        } else {
            const p = await Purchaser.find({query: {email: this.email}});
            const v = await Vendor.find({query: {email: this.email}});
            if (p.total !== 0) {
                (this.$refs.registerDialog as any).openWith(p.data[0], 'customer');
            } else if (v.total !== 0 && !v.data[0].disabled) {
                (this.$refs.registerDialog as any).openWith(v.data[0], 'pro');
            } else {
                // no purchaser with this email exists
                console.log(`no purchaser with this email exists`);
                this.showAlert(err);
            }
        }
    }

    private redirectAfterLogin() {
        if (this.userIsNull) {
            // do nothing
        } else if (this.userIsCustomer) {
            this.$router.replace(nil(this.redirectPath) ? '/' : this.redirectPath);
            this.redirectPath = null;
        } else if (this.userIsAdmin || this.userIsVendor) {
            this.$router.replace(nil(this.redirectPath) ? '/dashboard' : this.redirectPath);
            this.redirectPath = null;
        }
    }
    private get sizeStyle() {
        if (this.isXS(null)) {
            return 'min-width:350px';
        } else if (this.isSM(null)) {
            return 'min-width:400px';
        } else {
            return 'min-width:500px';
        }
    }
}
